module.exports = __webpack_public_path__ + "static/SnapCard-8fbd9bfd7cb02d79b6bf7e29ca258668.jpg";